var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-xs-12"},[(!_vm.hasChart)?_c('div',[_c('spinner'),_vm._v(" Desenhando os gráficos da estação. Por favor, aguarde... ")],1):_vm._e(),_vm._v(" "+_vm._s(_vm.noChartWarning)+" "),_c('div',{attrs:{"id":"monitoringStation"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }